import { useState } from "react";

export type WallPlannerEditModeType = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useWallPlannerEditMode = (): WallPlannerEditModeType => {
  const [loading, setLoading] = useState(false);
  return {
    loading,
    setLoading
  };
};
